// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import session from '../../../../share/session';
import error from '../../../../common/nodejs/errors';
import utils from "../../../../share/util/utils";
import cstmTable from "../../../../share/components/vue/PaginationTable";
import individualDiagnose from '../../../../share/util/individualDiagnose';
import apiService from '../../../../../../share/src/util/api/service';
import { executeSyncRequest } from '../../../../../../share/src/util/api/syncRequest';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import logWrapper from '../../../../share/logWrapper';

import { REQUEST_STATUS_COMPLETED, REQUEST_STATUS_FAILED } from '../../../../../../share/src/util/api/polling';

/** 各フェーズ定義 */
const PHASE = {
  STANDBY: "standby",
  START: "start",
  IN_PROGRESS: "inProgress",
  WRITE: "write",
  VARIANT_JUDGEMENT: "variantJudgement",
  INVALID_FORMAT: "invalidFormat",
  REGISTERED: "registered",
  VARIANT_SUCCESS: "variantSuccess",
  SELECT_ERROR: "selectError",
  SPEED_ERROR: "speedError",
  WRITE_ERROR: "writeError",
  VARIANT_ERROR: "variantError",
  INSTALLATION_ERROR: "installationError",
  ERROR: "error",
  CANCEL: "cancel"
};

/** API type定義 */
const API_TYPE = {
  CHECK: 'check',
  CHECK_ROMID: 'checkRomId',
  READ_REGISTRATION_JUDGMENT: 'readRegistrationJudgment',
  READ_REGISTERED: 'readRegistered',
  READ_ROMID: 'readRomId',
  READ_SSMID: 'readSSMId',
  START: 'start',
  START_ERROR: 'startError',
  SEC_ACCESS: 'secAccess',
  VAR_INIT: 'varInit',
  STATE_INITIALIZATION: 'stateInitialization',
  WRITE_VAR_CODE: 'writeVarCode',
  WRITE_ERROR: 'writeError',
  TERMINATE: 'terminate',
  TERMINATE_ERROR: 'terminateError',
  DISPOSE: 'dispose'
};

/** DefaultSession遷移 NonDefaultSession遷移 実行タイミング */
const SESSION = {
  JUDGE: 'judge',
  REGISTERED: 'registered',
  WRITE_VAR_CODE: 'writeVarCode',
  ERROR: 'error'
};

/** 共通エラーからの遷移かの判定フラグ */
const IS_SESSION = {
  SESSION: 0,
  COMMON_ERROR: 1
};

/** 現在セッション */
const CURRENT_SESSION = {
  DEFAULT: 1,
  NON_DEFAULT: 0
};

/** セキュリティアクセス
 *  エラー画面での処理か */
const PROCESS = {
  COMMON: 0,
  ERROR: 1
};

/** バリアントデータ登録判定からの遷移先 */
const TRANSITION = {
  STATE_INITIALIZATION: 0,
  REGISTERED: 1
};

// 検索条件
const SEARCH_YEAR_RANGE = 1;
const SEARCH_MONTH_RANGE = 12;

export default {
  name: "requirement114",
  data() {
    return {
      phase: PHASE.START,
      systemId: '',
      requirementId: 113,
      isLoading: false,
      isDispose: false,
      timerRegisterted: undefined,
      waitTime: null,
      readDataF182: null,
      currentSession: CURRENT_SESSION.DEFAULT,
      modelTableItems: [],
      modelBodyItems: [],
      gradeTableItems: [],
      gradeBodyItems: [],
      modal_requirement_114: false,
      buttonDisabled: true,
      selectedData: {},
      /** APIから取得した機能リストを常に保持しておく */
      originalDataList: [],
      /** 画面に表示する為の機能リスト */
      filteredDataList: [],
      deleteId: null,
      isError: false,
      selectedYear: '',
      selectedMonth: '',
      filterRegistrant: '',
      filterDataId: '',
      searchYearOptions: [''],
      searchMonthOptions: [''],
    };
  },

  props: {
    i18nWsKey: { type: String, default: "", required: true },
    workSupportId: { type: Number, default: "", required: true }
  },

  components: {
    "cstm-table": cstmTable
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.cache.vehicleInfo
    }),

    /** ダイアログのヘッダー色 **/
    headerColor() {
      switch (this.phase) {
        case PHASE.INVALID_FORMAT:
        case PHASE.SELECT_ERROR:
        case PHASE.SPEED_ERROR:
        case PHASE.WRITE_ERROR:
        case PHASE.VARIANT_ERROR:
        case PHASE.INSTALLATION_ERROR:
        case PHASE.ERROR:
        case PHASE.CANCEL:
          return "danger";
        case PHASE.START:
        case PHASE.IN_PROGRESS:
        case PHASE.REGISTERED:
        case PHASE.WRITE:
        case PHASE.VARIANT_JUDGEMENT:
        case PHASE.VARIANT_SUCCESS:
        default:
          return "secondary";
      }
    },

    modalSize() {
      switch (this.phase) {
        case PHASE.STANDBY:
          return 'xl';
        default:
          return 'md';
      }
    },

    /** 待機画面表示内容 */
    systemTableColumns() {
      return [
        { name: 'registered_at', label: 'individual.label_table_registration_date_ws114' },
        { name: 'vin', label: 'message.header_measured_data_list_vin' },
        { name: 'registered_by', label: 'individual.label_filter_registrants_ws114' },
        { name: 'data_id', label: 'individual.label_filter_data_id_ws114' }
      ];
    },

    /** アプライドモデル表示用 */
    modelTableColumns() {
      this.modelTableItems = [
        {
          name: "itemName",
          label: 'individual.label_table_7digit_model'
        }
      ];
      return this.modelTableItems;
    },

    /** グレード表示用 */
    gradeTableColumns() {
      this.gradeTableItems = [
        {
          name: "itemModel",
          label: 'individual.label_table_car_model'
        },
        {
          name: "itemEngine",
          label: 'individual.label_table_engine'
        },
        {
          name: "itemGear",
          label: 'individual.label_table_transmission'
        }
      ];
      return this.gradeTableItems;
    }
  },

  methods: {
    ...mapActions("auth", ["logout", "resetSession"]),

    /** 初期化処理 */
    init() {
      this.modal_requirement_114 = true;

      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
    },

    /** 終了処理を実施する */
    async endProcessing() {

      // dispose実施
      await this.doDispose();

      // 機能終了
      this.closeWizard();

      // 初期画面に戻す
      this.phase = PHASE.START;
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit("close-wizard");
      this.modal_requirement_114 = false;
    },

    /** その他エラー発生時の表示 */
    showUnexpectedError() {
      this.isError = true;
      // 異常終了：エラー表示
      this.phase = PHASE.ERROR;
    },

    /**
     * componentのmounted時に呼び出す処理
     */
    mountedLogic() {
      // 初期の検索条件の設定（現在の年、月）
      const currentYear = new Date().getFullYear();
      // 空白(全年検索用)+今年+去年を選択できるような選択肢配列を作成
      this.searchYearOptions = [''].concat([...Array(SEARCH_YEAR_RANGE + 1)].map((_, i) => String(currentYear - i)));
      // 空白(全月検索用)+1月-12月を選択できるような選択肢配列を作成
      this.searchMonthOptions = [''].concat([...Array(SEARCH_MONTH_RANGE)].map((_, i) => String(i + 1)));

      this.updateTable();
    },

    /**
     * テーブル行押下 
     */
    clickRow: function (selected) {
      this.selectedData = selected;
      this.setHighLight();
      this.buttonDisabled = false;
    },

    /**
     * 選択している機能のハイライト設定
     */
    setHighLight() {
      this.filteredDataList.forEach(item => {
        if (item === this.selectedData) {
          item.fieldSpec = {};
          item.fieldSpec.registered_at = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.vin = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.registered_by = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.data_id = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /**
     * 選択状態を解除し、フィルターの文字列に応じてリストをフィルターする
     */
    searchFilter() {
      this.selectedData = {};
      this.setHighLight();
      this.buttonDisabled = true;

      this.$nextTick(() => {
        this.filteredDataList = this.originalDataList.filter(item => {
          // 翻訳後の名称を大文字・小文字区別なくフィルターする
          const yearFilter = this.selectedYear.toLowerCase();
          const monthFilter = this.selectedMonth.toLowerCase();
          const itemYear = new Date(item.registered_at).getFullYear().toString();
          const itemMonth = new Date(item.registered_at).getMonth() + 1;

          return (
            (yearFilter === "" || itemYear.includes(yearFilter)) &&
            (monthFilter === "" || itemMonth === Number(monthFilter)) &&
            item.registered_by.toLowerCase().includes(this.filterRegistrant.toLowerCase()) &&
            item.data_id.toString().toLowerCase().includes(this.filterDataId.toLowerCase())
          );
        });
      });
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    // API実行 -------------------------------------------

    /** バリアントデータ取得確認
     * @param {String} apiType API種別
     */
    async doCheck(apiType) {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: apiType,
        };

        if (apiType === API_TYPE.CHECK_ROMID) {
          requestBody.read_data = this.readDataF182;
        }

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              switch (apiType) {
                case API_TYPE.CHECK:
                  // 不正フォーマット表示用にウェイト時間を控える
                  this.waitTime = response.data.user_data.wait_time;
                  await this.mountedLogic();
                  break;
                case API_TYPE.CHECK_ROMID:
                  // 表示内容を設定
                  this.setDisplayContents(response.data.user_data);
                  break;
                default:
                  break;
              }
              break;
            case REQUEST_STATUS_FAILED:
              switch (response.data.async_code) {
                case error.WSP_114_NO_MATCH_DATA:
                  this.isError = true;
                  await this.endProcessing();
                  break;
                case error.WSP_GENERAL_ERROR:
                default:
                  // 該当のエラーコードが存在しない場合、共通エラー
                  // ありえないが定義しておく
                  this.showUnexpectedError();
                  break;
              }
              break;
            default:
              // 共通エラーに遷移
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** テーブル情報更新 */
    async updateTable() {
      try {
        this.isLoading = true;
        //バックエンドAPI GETのみ
        const response = await executeSyncRequest(
          this,
          async () => {
            return await apiService.getParamCall(
              apiService.WSP,
              '/readData/requirements/' + this.requirementId,
              {
                vin: this.vehicleInfo.vehicle.vin.vin,
                system_name: this.systemId,
                work_support_id: this.workSupportId
              }
            );
          },
          // エラー発生のコールバック
          (errorType) => {
            logWrapper.log("errorCallback called.", errorType, true);
            this.showUnexpectedError();
          },
          undefined,
          // API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          if (response.data.status === REQUEST_STATUS_FAILED) {
            switch (response.data.async_code) {
              case error.WSP_114_INVALID_FORMAT:
                // 不正フォーマット表示
                this.phase = PHASE.INVALID_FORMAT;
                this.close();
                return;
              case error.WSP_GENERAL_ERROR:
              default:
                // 該当のエラーコードが存在しない場合、共通エラー
                // ありえないが定義しておく
                this.showUnexpectedError();
                return;
            }
          }

          // データ選択画面に遷移
          await this.startDataSet(response);
          this.phase = PHASE.STANDBY;
          this.searchFilter();
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** バリアントコード復号化 */
    async variantCodeDecoding() {
      try {
        this.isLoading = true;
        this.deleteId = this.selectedData.data_id;

        //バックエンドAPI GETのみ
        const response = await executeSyncRequest(
          this,
          async () => {
            return await apiService.getParamCall(
              apiService.WSP,
              '/readData/requirements/' + this.requirementId,
              {
                vin: this.selectedData.vin,
                system_name: this.systemId,
                work_support_id: this.workSupportId,
                data_id: this.selectedData.data_id
              }
            );
          },
          // エラー発生のコールバック
          (errorType) => {
            logWrapper.log("errorCallback called.", errorType, true);
            this.showUnexpectedError();
          },
          undefined,
          // API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          if (response.data.status === REQUEST_STATUS_FAILED) {
            switch (response.data.async_code) {
              case error.WSP_114_INVALID_FORMAT:
                // 不正フォーマット表示
                this.phase = PHASE.INVALID_FORMAT;
                this.close();
                return;
              case error.WSP_GENERAL_ERROR:
              default:
                // 該当のエラーコードが存在しない場合、共通エラー
                // ありえないが定義しておく
                this.showUnexpectedError();
                return;
            }
          }

          await this.doRead(API_TYPE.READ_REGISTRATION_JUDGMENT);
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** データ読出し
     * @param {String} apiType API種別
     */
    async doRead(apiType) {
      try {
        this.isLoading = true;

        /** バリアントデータ登録判定 */
        // API実行パラメータ作成
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: apiType,
        };

        switch (apiType) {
          case API_TYPE.READ_REGISTRATION_JUDGMENT:
            // CCと通信を行う初回処理のためDispose実行フラグを立てる
            this.isDispose = true;
            break;
          case API_TYPE.READ_ROMID:
          case API_TYPE.READ_SSMID:
            // バックエンドに送る値を設定
            requestBody.data_id = this.selectedData.data_id;
            break;
          default:
            break;
        }

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              await this.successReadResponse(apiType, response.data);
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了
              await this.failedReadResponse(response.data);
              break;
            default:
              // 該当のエラーコードが存在しない場合、共通エラー
              // ありえないが定義しておく
              this.showUnexpectedError();
              break;
          }
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** NonDefaultSession遷移
     * @param {String} sessionType Session遷移実行タイミング
     */
    async doStart(sessionType) {
      try {
        this.isLoading = true;
        let apiType = undefined;

        // バックエンドに送る値を設定
        switch (sessionType) {
          case SESSION.JUDGE:
          case SESSION.REGISTERED:
            apiType = API_TYPE.START;
            break;
          case SESSION.ERROR:
            apiType = API_TYPE.START_ERROR;
            break;
          default:
            this.showUnexpectedError();
            break;
        }

        // API実行パラメータ作成
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: apiType,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              await this.successStartResponse(sessionType);
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了
              await this.failedStartResponse(response.data);
              break;
            default:
              // 該当のエラーコードが存在しない場合、共通エラー
              // ありえないが定義しておく
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ読出し セキュリティアクセス
     * @param {String} process 現在処理が正常系なのかエラー画面での処理なのか
     */
    async doSecAccess(process) {
      try {
        this.isLoading = true;

        // EUCキーの取得
        const token = session.getToken();

        // データ読出し (要求)
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          // POST リクエストの body を指定する
          {
            id_token: token.id_token,
            type: API_TYPE.SEC_ACCESS,
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              await this.successSecAccessResponse(process);
              break;
            case REQUEST_STATUS_FAILED:
            default:
              // 該当のエラーコードが存在しない場合、共通エラー
              // ありえないが定義しておく
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** データ書き込み
     * @param {String} apiType API種別
     */
    async doWrite(apiType) {
      try {
        this.isLoading = true;

        // EUCキーの取得
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: apiType,
        };

        if (apiType === API_TYPE.WRITE_VAR_CODE) {
          // バリアントコード書込み時のみAPIに渡すパラメータを追加
          requestBody.data_id = this.selectedData.data_id;
        }

        // データ読出し (要求)
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case REQUEST_STATUS_COMPLETED:
              // 正常終了
              await this.successWriteResponse(apiType);
              break;
            case REQUEST_STATUS_FAILED:
              // 異常終了
              await this.failedWriteResponse(response.data);
              break;
            default:
              // 該当のエラーコードが存在しない場合、共通エラー
              // ありえないが定義しておく
              this.showUnexpectedError();
              break;
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** DefaultSession遷移
     * @param {String} sessionType Session遷移実行タイミング
     * @param {Number} isSession 共通エラーかどうか
     */
    async doTerminate(sessionType, isSession) {
      try {
        this.isLoading = true;
        let apiType = undefined;

        // バックエンドに送る値を設定
        switch (sessionType) {
          case SESSION.WRITE_VAR_CODE:
            apiType = API_TYPE.TERMINATE;
            break;
          case SESSION.ERROR:
            apiType = API_TYPE.TERMINATE_ERROR;
            break;
          default:
            this.showUnexpectedError();
            break;
        }

        // API実行パラメータ作成
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: apiType,
        };

        // 初期処理（要求）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (isSession === IS_SESSION.COMMON_ERROR) {
          // 機能終了
          await this.endProcessing();
          return;
        } else {
          if (response) {
            switch (response.data.status) {
              case REQUEST_STATUS_COMPLETED:
                // 正常終了
                await this.successTerminateResponse(sessionType, response.data);
                break;
              case REQUEST_STATUS_FAILED:
              default:
                // 共通エラー
                this.showUnexpectedError();
                break;
            }
          }
        }
      } finally {
        this.isLoading = false;
      }
    },

    /** 終了処理 */
    async doDispose() {
      try {
        this.isLoading = true;

        // API実行パラメータ作成
        const token = session.getToken();
        const requestBody = {
          id_token: token.id_token,
          type: API_TYPE.DISPOSE,
          data_id: this.deleteId,
          is_error: this.isError,
        };

        await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          requestBody,
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

      } finally {
        this.isLoading = false;
        // deleteId初期化
        this.deleteId = null;
      }
    },

    // APIレスポンス -------------------------------------------

    /** READ API成功時の処理
     * @param {String} apiType API種別
     * @param {Object} tmpResponse APIレスポンス
     */
    async successReadResponse(apiType, tmpResponse) {
      switch (apiType) {
        case API_TYPE.READ_REGISTRATION_JUDGMENT:
          if (tmpResponse.user_data.transition === TRANSITION.STATE_INITIALIZATION) {
            // 読出し結果 0xFFFFFFFFFF
            await this.doStart(SESSION.JUDGE);
          } else {
            // 登録済み表示
            // 待機時間を控える
            this.waitTime = tmpResponse.user_data.wait_time;
            this.phase = PHASE.REGISTERED;
            this.specifiedTimeElapsedRegistered();
          }
          break;
        case API_TYPE.READ_REGISTERED:
          // バリアントコード初期化に遷移
          await this.doSecAccess(PROCESS.COMMON);
          break;
        case API_TYPE.READ_ROMID:
          // データ読出し実行
          this.readDataF182 = tmpResponse.user_data.read_romid;
          await this.doRead(API_TYPE.READ_SSMID);
          break;
        case API_TYPE.READ_SSMID:
          // キャンセル表示用の待機時間を控える
          this.waitTime = tmpResponse.user_data.wait_time;
          // バリアントデータ判定に遷移
          this.phase = PHASE.VARIANT_JUDGEMENT;
          break;
        default:
          this.showUnexpectedError();
          break;
      }
    },

    /** READ API失敗時の処理
     * @param {object} tmpResponse APIレスポンス
     */
    async failedReadResponse(tmpResponse) {
      this.isError = true;
      switch (tmpResponse.async_code) {
        case error.WSP_114_SUPPLEMENTARY_PARTS_INSTALLATION:
          // 補用品取付け確認表示
          this.waitTime = tmpResponse.user_data.wait_time;
          this.InstallationOfSpareParts();
          break;
        case error.WSP_114_PARAMETER_SELECTION_NOT_POSSIBLE:
          // パラメータ選択不可表示
          this.waitTime = tmpResponse.user_data.wait_time;
          this.selectParamError();
          break;
        case error.WSP_114_INCORRECT_DISPLAY_OF_VARIANT_DATA:
          // バリアントデータ不正表示
          this.waitTime = tmpResponse.user_data.wait_time;
          this.invalidVariantData();
          break;
        case error.WSP_GENERAL_ERROR:
        default:
          // 該当のエラーコードが存在しない場合、共通エラー
          // ありえないが定義しておく
          this.showUnexpectedError();
          break;
      }
    },

    /** START API成功時の処理
     * @param {String} tmpSessionType Session遷移実行タイミング
     */
    async successStartResponse(tmpSessionType) {
      // 現在セッションをNonDefaultSessionに設定
      this.currentSession = CURRENT_SESSION.NON_DEFAULT;

      switch (tmpSessionType) {
        case SESSION.JUDGE:
          // パラメータ初期化に遷移
          await this.doWrite(API_TYPE.STATE_INITIALIZATION);
          break;
        case SESSION.REGISTERED:
          // データ読出し実行
          await this.doRead(API_TYPE.READ_REGISTERED);
          break;
        case SESSION.ERROR:
          await this.doSecAccess(PROCESS.ERROR);
          break;
        default:
          this.showUnexpectedError();
          break;
      }
    },

    /** START API失敗時の処理
     * @param {object} tmpResponse APIレスポンス
     */
    async failedStartResponse(tmpResponse) {
      this.isError = true;
      switch (tmpResponse.async_code) {
        case error.WSP_114_WHEEL_OVERSPEED:
          // 車輪速超過表示
          this.phase = PHASE.SPEED_ERROR;
          this.waitTime = tmpResponse.user_data.wait_time;
          this.waitClose();
          break;
        case error.WSP_GENERAL_ERROR:
        default:
          // 該当のエラーコードが存在しない場合、共通エラー
          // ありえないが定義しておく
          this.showUnexpectedError();
          break;
      }
    },

    /** SEC_ACCESS API成功時の処理
     * @param {String} process 現在処理が正常系なのかエラー画面での処理なのか
     */
    async successSecAccessResponse(process) {
      switch (process) {
        case PROCESS.COMMON:
          // パラメータ初期化に遷移
          await this.doWrite(API_TYPE.VAR_INIT);
          break;
        case PROCESS.ERROR:
          await this.doWrite(API_TYPE.WRITE_ERROR);
          break;
        default:
          this.showUnexpectedError();
          break;
      }
    },

    /** WRITE API成功時の処理
     * @param {String} apiType API種別
     */
    async successWriteResponse(apiType) {
      switch (apiType) {
        case API_TYPE.VAR_INIT:
          // キャリブレーション状態初期化に遷移
          await this.doWrite(API_TYPE.STATE_INITIALIZATION);
          break;
        case API_TYPE.STATE_INITIALIZATION:
          // バリアントコード書込みに遷移
          await this.doWrite(API_TYPE.WRITE_VAR_CODE);
          break;
        case API_TYPE.WRITE_VAR_CODE:
          await this.doTerminate(SESSION.WRITE_VAR_CODE, IS_SESSION.SESSION);
          break;
        case API_TYPE.WRITE_ERROR:
          await this.doTerminate(SESSION.ERROR, IS_SESSION.SESSION);
          break;
        default:
          this.showUnexpectedError();
          break;
      }
    },

    /** WRITE API失敗時の処理
     * @param {object} tmpResponse APIレスポンス
     */
    async failedWriteResponse(tmpResponse) {
      this.isError = true;
      switch (tmpResponse.async_code) {
        case error.WSP_114_PARAMETER_SELECTION_NOT_POSSIBLE:
          this.waitTime = tmpResponse.user_data.wait_time;
          // パラメータ選択不可表示
          this.selectParamError();
          break;
        case error.WSP_114_WRITE_FAILURE:
          this.waitTime = tmpResponse.user_data.wait_time;
          // 書込み失敗表示
          this.writeFailure();
          break;
        case error.WSP_GENERAL_ERROR:
        default:
          // 該当のエラーコードが存在しない場合、共通エラー
          // ありえないが定義しておく
          this.showUnexpectedError();
          break;
      }
    },

    /** TERMINATE API成功時の処理
     * @param {String} tmpSessionType Session遷移実行タイミング
     * @param {object} tmpResponse APIレスポンス
     */
    async successTerminateResponse(tmpSessionType, tmpResponse) {
      // 現在セッションをDefaultSessionに設定
      this.currentSession = CURRENT_SESSION.DEFAULT;

      // 正常終了
      switch (tmpSessionType) {
        case SESSION.WRITE_VAR_CODE:
          // データ書込み画面に遷移
          this.phase = PHASE.WRITE;
          this.waitTime = tmpResponse.user_data.wait_time;
          await this.doWritingWait();
          // 指定時間経過後データ読出し処理
          await this.doRead(API_TYPE.READ_ROMID);
          break;
        case SESSION.ERROR:
          // 機能終了
          this.isError = true;
          await this.endProcessing();
          return;
        default:
          // 該当のエラーコードが存在しない場合、共通エラー
          // ありえないが定義しておく
          this.showUnexpectedError();
          break;
      }
    },

    /** 指定時間待機 (スピナー無) */
    async doWait() {
      // 指定時間待機
      await utils.sleep(this.waitTime);
      this.waitTime = null;
    },

    /** 指定時間待機 (スピナー有) */
    async doWritingWait() {
      try {
        this.isLoading = true;

        // 指定時間待機
        await utils.sleep(this.waitTime);
        this.waitTime = null;
      } finally {
        this.isLoading = false;
      }
    },

    /** ウィンドウを閉じる */
    async noWaitClose() {
      this.closeWizard();
    },

    /** 指定時間経過後ウィンドウを閉じる */
    async close() {
      await this.doWait();
      this.closeWizard();
    },

    /** 指定時間経過後disposeAPIを実施 */
    async waitClose() {
      await this.doWait();
      this.endProcessing();
    },

    /** 指定時間経過でバリアントデータ登録済み表示を閉じる */
    specifiedTimeElapsedRegistered() {
      this.isError = true;
      // 「OK」ボタンを押されなかった場合機能終了する
      this.timerRegisterted = setTimeout(() => {
        this.endProcessing();
      }, this.waitTime);

      this.waitTime = null;
    },

    // 異常系 -----------------------------------------------
    /**
     * パラメータ選択不可表示
     */
    async selectParamError() {
      this.phase = PHASE.SELECT_ERROR;
      await this.doWait();
      this.doTerminate(SESSION.ERROR, IS_SESSION.SESSION);
    },

    /**
     * 書込み失敗表示
     */
    async writeFailure() {
      this.phase = PHASE.WRITE_ERROR;
      await this.doWait();
      this.doTerminate(SESSION.ERROR, IS_SESSION.SESSION);
    },

    /**
     * バリアントデータ不正表示
     */
    async invalidVariantData() {
      this.phase = PHASE.VARIANT_ERROR;
      await this.doWait();
      this.doStart(SESSION.ERROR);
    },

    /**
     * キャンセル表示
     */
    async cancelDisplay() {
      this.phase = PHASE.CANCEL;
      await this.doWait();
      this.doStart(SESSION.ERROR);
    },

    /**
     * 補用品取付け確認表示
     */
    async InstallationOfSpareParts() {
      this.phase = PHASE.INSTALLATION_ERROR;
      await this.doWait();
      this.doTerminate(SESSION.ERROR, IS_SESSION.SESSION);
    },

    // 表示内容設定 -------------------------------------------

    /**
     * 待機画面データセット
     * @param {object} response APIレスポンス
     */    
    startDataSet(response) {
      // 正常終了：一覧データ取得
      this.filteredDataList = response.data.read_data_list;
      // registered_at(UNIXTIME)をYYYY/MM/DD HH:mm:ss形式に変換
      this.filteredDataList.forEach(item => {
        item.registered_at = utils.timeConverter(item.data_id);
      });

      this.originalDataList = this.filteredDataList;
    },

    /** 
     * 停止画面表示内容をセットする
     * @param {Array} tmpVariantData APIレスポンス バリアントデータ
     */
    setDisplayContents(tmpVariantData) {
      // 停止画面に遷移
      this.phase = PHASE.VARIANT_SUCCESS;

      const showAppliedModel = [];
      let showGrade = [];
      const tmpAppliedModel = tmpVariantData.applied_model;
      const tmpGrade = tmpVariantData.grade;

      this.$nextTick(() => {
        // 表示するアプライドモデル設定
        tmpAppliedModel.forEach(elementModel => {
          const itemModel = {
            itemName: elementModel
          };
          showAppliedModel.push(itemModel);
        });
        this.modelBodyItems = showAppliedModel;
      });

      if (this.$parent.$i18n.locale === 'ja') {
        // 表示言語が日本語
        this.$nextTick(() => {
          // 表示するグレード設定
          tmpGrade.forEach(elementGrade => {
            const itemGrade = {
              itemModel: elementGrade.car_model,
              itemEngine: elementGrade.engine,
              itemGear: elementGrade.transmission1
            };

            // 表示内容を設定
            showGrade = this.addShowData(showGrade, itemGrade);
          });
          this.gradeBodyItems = showGrade;
        });
      } else {
        // 表示言語が日本語以外
        this.$nextTick(() => {
          // 表示するグレード設定
          tmpGrade.forEach(elementGrade => {
            const itemGrade = {
              itemModel: elementGrade.car_model,
              itemEngine: elementGrade.engine,
              itemGear: elementGrade.transmission2
            };

            // 表示内容を設定
            showGrade = this.addShowData(showGrade, itemGrade);
          });

          this.gradeBodyItems = showGrade;
        });
      }
    },

    /**
     * 表示内容を設定
     * @param {Object} showGrade 表示内容全体
     * @param {Object} itemGrade 表示内容単体
     * @returns 
     */
    addShowData(showGrade, itemGrade) {
      if (showGrade.length === 0) {
        // showGradeに何も入っていなければ追加
        showGrade.push(itemGrade);
      } else {
        if (showGrade.some((obj) => obj.itemModel === itemGrade.itemModel
          && obj.itemEngine === itemGrade.itemEngine
          && obj.itemGear === itemGrade.itemGear)) {
          // 全一致の場合は含めない

        } else {
          // 全一致でなければ追加
          showGrade.push(itemGrade);
        }
      }

      return showGrade;
    },

    // ユーザ操作 -------------------------------------------

    /** バリアントデータ判定「OK」押下 */
    variantJudgementOkClicked() {
      this.doCheck(API_TYPE.CHECK_ROMID);
    },

    /** バリアントデータ登録済み表示「OK」押下 */
    registeredOkClicked() {
      this.isError = false;
      clearTimeout(this.timerRegisterted);
      this.doStart(SESSION.REGISTERED);
    },

    /** 停止画面にて「OK」押下 */
    onStopOkClicked() {
      this.endProcessing();
    },

    /** 停止画面にて「キャンセル」押下 */
    onCancelClicked() {
      this.cancelDisplay();
    },

    /** エラー画面 OK押下処理 */
    onErrorOkClicked() {
      if (this.currentSession === CURRENT_SESSION.NON_DEFAULT) {
        // 現在セッションがNonDefaultSessionの場合DefaultSession遷移実行
        this.doTerminate(SESSION.ERROR, IS_SESSION.COMMON_ERROR);
      } else {
        if (this.isDispose) {
          // disposeが必要か
          this.endProcessing();
          this.isDispose = false;
        } else {
          // [REQ.WS.114.SBY.2] で共通エラーに遷移した場合はCCとの通信がないためdispose不要
          this.closeWizard();
        }
      }
    }
  },

  async mounted() {
    this.init();

    // 処理開始
    this.doCheck(API_TYPE.CHECK);
  }
};
